import { Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { useWelcomeQuery } from '../../api/getWelcomeDetails';
import { useSnackbarsContext } from '../../store/SnackbarProvider';
import { capitalizeName, getCustomerName } from '../../utils/helpers';

const SubHeader = () => {
  const location = useLocation();
  const { data } = useWelcomeQuery();
  const { snackbarVisible } = useSnackbarsContext();

  const { firstName } = getCustomerName(data);

  const welcomeMessage = `${capitalizeName(
    firstName
  )}'s ${location.pathname.replace('/', '')}`;

  return (
    <Box
      data-testid="subHeader"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mb: { mobile: 2, tablet: 3 },
        mt: snackbarVisible
          ? { mobile: 1, tablet: 2, desktop: 4 }
          : { mobile: 2, tablet: 3, desktop: 9 },
        width: 1,
      }}
    >
      <Typography
        variant="h1"
        className="csaa-qm-encrypt"
        sx={{
          fontSize: { mobile: 33, tablet: 44 },
          fontWeight: 500,
          lineHeight: '40px',
        }}
      >
        {welcomeMessage}
      </Typography>
    </Box>
  );
};

export default SubHeader;
